<template>
	<BackButton :text="t('back_button.overview')" link="Home" />
	<div v-if="te('gallery')" class="container-fluid h-100 w-100">
		<h3 class="text-center museum-titel-test">{{ t('puzzle_text.overview') }}</h3>
		<div class="d-flex">
			<div class="gallery-grid mx-auto museum-footer-mbs">
				<PuzzleOverviewItem :title="puzzle.post_title" :image="puzzle.thumbnail" :id="index" v-for="(puzzle, index) in tm('puzzle')" :key="puzzle" />
			</div>
		</div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";
import PuzzleOverviewItem from "@/components/puzzle/OverviewItem.vue";
import BackButton from "@/components/buttons/BackButton.vue";

export default {
	name: "PuzzleOverview",
	components: {
		PuzzleOverviewItem,
		BackButton,
	},
	setup() {
		const { t, te, tm } = useI18n();
		return { t, te, tm };
	},
};
</script>

<style scoped>
.gallery-grid {
	margin-top: 240px;
	display: grid;
	grid-template-columns: auto auto auto;
	grid-template-rows: repeat(auto-fill, 400px);
	column-gap: 41px;
}
</style>